import React, { useEffect } from "react";
import { withRouter } from "react-router-dom";
import RestrictAccess from "../RestrictedAccess";
import AuthContainer from "../../../store/container/AuthContainer";
import { AppRoutes } from "../../../routes/routeConstants/appRoutes";

const requireAuth = (Component: any, allowedRoles: any = []) => {
  const Authentication = (props: any) => {
    const { authenticated, history, user } = props;

    useEffect(() => {
      if (!authenticated && history.location.pathname !== AppRoutes.LOGIN) {
        history.push(AppRoutes.LOGIN);
      }
    }, [authenticated, history.location.pathname]);

    if (allowedRoles.length) {
      return allowedRoles.includes(user?.role) ? (
        <Component {...props} />
      ) : (
        <RestrictAccess />
      );
    }

    return <Component {...props} />;
  };

  return withRouter(React.memo(AuthContainer(Authentication)));
};

export default requireAuth;
